module.exports = __webpack_public_path__ + "img/HHbemleklap2024.238bdf00.jpg";